var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'fixed top-8px right-24px z-[100] py-9px px-32px bottom-24px bg-gray-7 rounded-20 w-fit h-fit transition-opacity duration-150 ease-linear',
  ]},[_c('span',{staticClass:"text-white text-18 font-600 leading-[22px]"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }